import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../../auth';
import config from 'cfg';
import styled from 'styled-components';
import RCore from 'RCore';

import IconUpload from 'material-ui/svg-icons/file/file-upload';
import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconError from 'material-ui/svg-icons/content/clear';
import Snackbar from 'material-ui/Snackbar';

import WidgetNestedMenu from './WidgetNestedMenu';
import SWTProvider, { loadDataFunc as templateLoadData } from '../../../../widgets/components/core/SWTProvider';
import WDPContext from '../../../../widgets/components/core/WDPContext';

import { styledUI } from '../../../../widgets/components/sm/StyledUI';
import SplitImageTPLEditor from '../../../../widgets/components/sm/templates/SplitImageTPLEditor';
import DEFAULT_THEME from '../../../../widgets/components/sm/templates/SplitImageTPLDefaultTheme';

var C_TEMPLATE_SCREEN_SIZE_KEY = 'C_TEMPLATE_SCREEN_SIZE_KEY_2';

const PreviewContainerWrapper = styled.div`
    .sm-wdp:hover {
        [class*='__c__'] {
            cursor: pointer;
            box-shadow: 0px 0px 0px 3px currentColor;
        }
    }
`;

const DisplayElementTitle = styled.p`
    position: absolute;
    left: 0;
    top: -35px;
    color: ${props => props.color || '#fff'};
`;

const StandardComponentExample = styled.div`
    margin: 15px 0;
    padding: 15px 0;
    position: relative;
    border-top: 1px dashed ${props => props.color || '#fff'};
`;

function cancellable(func) {
    var cancelled = false;

    var cancellabled = function () {
        if (!cancelled) {
            func(...arguments);
        }
    };

    cancellabled.cancel = function () {
        cancelled = true;
        if (typeof func.onCancel === 'function') {
            func.onCancel();
        }
    };

    return cancellabled;
}

function difference(object, base) {
    function changes(object, base) {
        return _.transform(object, function (result, value, key) {
            const isEqual = _.isEqual(value, base[key]);
            const isPrimitive = _.isNumber(value) || _.isString(value) || _.isBoolean(value);

            if (!isEqual && isPrimitive) {
                result[key] = value;
            } else if (
                !_.isArray(value) &&
                _.isObject(value) &&
                _.isObject(base[key]) &&
                !_.isEmpty(value) &&
                !isEqual
            ) {
                const newObj = changes(value, base[key]);
                if (!_.isEmpty(newObj)) result[key] = newObj;
            } else if (_.isArray(value)) {
                const hash = base[key] && base[key].map(e => _.values(e).join('.')).join(',');
                const hash2 = value && value.map(e => _.values(e).join('.')).join(',');

                if (value.length && hash !== hash2) {
                    result[key] = value;
                }
            } else if (isEqual) {
                // console.log('else', key, value, base[key]);
            }
        });
    }

    return changes(object, base);
}

const displayProps = {
    tournamentTable: {
        row: {
            goalsConceded: 18,
            goalsScored: 28,
            groupName: 'Superligaen',
            matchesDraw: 2,
            matchesLost: 2,
            matchesPlayed: 11,
            matchesWon: 7,
            overtimeLost: 0,
            overtimeWon: 0,
            points: 23,
            pointsConceded: 0,
            pointsScored: 0,
            rank: 1,
            rankType: 'championship_playoff',
            sportId: 1,
            standingId: 236888,
            teamId: 10202,
            teamName: 'FC Nordsjaelland',
            teamShortName: 'FCN',
            tournamentStageId: 849851,
            tournamentStageName: 'Superleague',
        },
        tournamentId: 46,
    },
    title: {
        title: 'Title example',
        subTitle: 'Subtitle here',
    },
    playersList: {
        rank: 0,
        player: {
            id: 175753,
            name: 'Paal Alexander Kirkevold',
            teamId: 9950,
            value: 10,
        },
        seasonId: 11488,
        valueTitle: 'goals',
    },
    matchCell: {
        event: {
            _id: '5938a41c0b77a7617ca0650e',
            eventId: 2511285,
            startDate: '2017-10-13T17:00:00.000Z',
            statusType: 'notstarted',
            statusFull: 'Not started',
            homeId: 8487,
            awayId: 8113,
            homeName: 'SoenderjyskE',
            awayName: 'FC Midtjylland',
            homeShortName: 'SJE',
            awayShortName: 'FCM',
            homeCountryId: 1,
            awayCountryId: 1,
            countryId: 1,
            country: 'Denmark',
            tournamentName: 'Superleague',
            tournamentStageId: 849851,
            tournamentYear: '2017/2018',
            tournamentId: 11488,
            tournamentTemplateId: 46,
            sportId: 1,
            sport: 'football',
            teams: [8487, 8113],
            version: 7,
            score: {
                away: '0',
                home: '0',
            },
            properties: {
                round: '12',
                live: 'yes',
                venueName: 'Sydbank Park',
                liveStatsType: 'livestats',
                startDateTimeToBeDecided: 'yes',
                commentary: 'full',
            },
        },
    },
    h2hTable: {
        dataset: [
            {
                away: 36,
                home: 46,
                max: 46,
                label: 'points',
                lessIsBetter: true,
                prefix: '#',
            },
            {
                away: 7,
                home: 1,
                max: 9,
                label: 'goals',
            },
            {
                away: 5,
                home: 25,
                max: 48,
                label: 'assists',
            },
            {
                away: 48.6,
                home: 52.5,
                max: 72.4,
                label: 'average Speed',
            },
            {
                away: 2,
                home: 4,
                max: 4,
                label: 'key Passes',
            },
            {
                away: 3,
                home: 5,
                max: 5,
                label: 'shotsOnGoal',
            },
        ],
        isH2H: true,
        chartHeight: 400,
        event: {
            homeShortName: 'RFC',
            awayShortName: 'ACH',
            statusFull: 'Finished',
            statusType: 'finished',
            tournamentTemplateId: 46,
            homeId: 8410,
            awayId: 9814,
            score: {
                away: '1',
                home: '0',
            },
        },
        h2h: {
            homeTeam: {
                wins: 4,
            },
            awayTeam: {
                wins: 5,
            },
            draws: 1,
        },
        form: {
            home: {
                short_results: [
                    { type: 'home', result: 'draw' },
                    { type: 'home', result: 'draw' },
                    { type: 'away', result: 'loss' },
                    { type: 'away', result: 'win' },
                    { type: 'home', result: 'draw' },
                    { type: 'away', result: 'loss' },
                ],
            },
            away: {
                short_results: [
                    { type: 'away', result: 'draw' },
                    { type: 'home', result: 'draw' },
                    { type: 'away', result: 'loss' },
                    { type: 'home', result: 'draw' },
                    { type: 'away', result: 'draw' },
                    { type: 'home', result: 'win' },
                ],
            },
        },
        limit: 6,
        title: 'Latest',
        h2hTitle: {
            title: 'Latest H-2-H',
            draw: 'Draw',
        },
    },
};

class TemplateCustomizer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            previewSize: localStorage.getItem(C_TEMPLATE_SCREEN_SIZE_KEY) || '800px',
            saveDialogue: false,
            demoIndex: 0,
            theme: _.clone(DEFAULT_THEME),
            downloadTemplateProcess: false,
            downloadTemplateError: false,
            snackbarOpen: false,
            snackbarText: '',
            importFileLoaded: false,
        };
        this.loadData();
    }

    componentDidMount = () => { };

    componentWillReceiveProps = (nextProps, nextState) => {
        const { wid, variation } = this.state;
        const newWid = _.get(nextProps, 'router.location.query.wid');
        const newVariation = _.get(nextProps, 'router.location.query.variation');

        if (newWid !== wid || variation !== newVariation) {
            this.setState(
                {
                    r: Math.round(),
                },
                () => {
                    this.loadData();
                },
            );
        }
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        widgets: PropTypes.array.isRequired,
    };

    loadData = () => {
        const tid = _.get(this.props, 'location.query.tid');
        const wid = _.get(this.props, 'location.query.wid');
        const variation = _.get(this.props, 'location.query.variation');

        var user = this.context.user;
        const { client, username } = user;

        const authToken = auth.getAccessToken();

        return RCore.promiseProps({
            template: fetch(`${config.dash.api.host}/api/clients/${client}/users/${username}/templates/${tid}`).then(
                response => response.json(),
            ),
            widgetTemplate: Reflect.apply(templateLoadData, this, [client, username, tid, wid, variation]),
            widgets:
                this.state.widgets ||
                fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${authToken}`)
                    .then(response => response.json())
                    .then(resp => [...resp.widgets]),
            wid,
            tid,
            variation,
        })
            .then(res => {
                const { widgetTemplate } = res;

                this.setState({ theme: widgetTemplate.theme, ...res }, () => {
                    if (wid) this.loadWidget();
                });
            })
            .catch(err => {
                console.log(err);
            });
    };

    loadWidget = () => {
        const { wid } = this.state;
        this.widgetRequestCallback = cancellable(() => {
            this.setState({
                [wid]: true,
            });
        });

        if (wid && !this.state[wid]) {
            window.wdpload(wid, {}, {}, this.widgetRequestCallback);
        }
    };

    handleSaveOrUpdate = () => {
        var { tid, wid, variation } = this.state;
        let url = `${config.dash.api.host}/api/templates`;
        if (tid) url = url + `?id=${tid}`;

        let toSave = this.state.theme;

        if (wid) {
            // if we are saving widget
            toSave = { ...this.state.template.theme };
        }

        return fetch(url, {
            method: 'post',
            body: JSON.stringify({
                name: this.state.name,
                template: 'SplitImageTPL',
                theme: toSave,
            }),
            headers: {
                'Content-Type': 'application/json',
                authorization: auth.getAccessToken(),
            },
        })
            .then(response => response.json())
            .then(tpl => {
                this.context.router.replace({
                    ...this.props.location,
                    query: { tid: tid || tpl.id, wid, variation },
                });
                this.setState({
                    saveDialogue: false,
                    snackbarOpen: true,
                    snackbarText: 'DONE: Template saved',
                });
            })
            .catch(err => {
                console.error(err);
                this.setState({
                    saveDialogue: false,
                    snackbarOpen: true,
                    snackbarText: 'ERROR: Sorry, there was an error',
                });
            });
    };

    renderDisplay = () => {
        const { user } = this.context;
        const { theme, wid, template } = this.state;

        if (_.isEmpty(theme)) return null;

        const displayComponents = Object.keys(theme.display).map(element => {
            const Component = styledUI.getDisplay({ theme }, element);
            const componentProps = displayProps[element];

            if (!Component || _.isEmpty(componentProps)) return <div />;

            let Wrapper;
            const elementTitle = `Standard component "${element}" - ${_.get(theme, `display[${element}]`, 'default')}`;

            switch (element) {
                // case 'tournamentTable':
                //     Wrapper = props => {
                //         return (
                //             <StandardComponentExample color={theme.color}>
                //                 <DisplayElementTitle>{elementTitle}</DisplayElementTitle>
                //                 <div>{props.children}</div>
                //             </StandardComponentExample>
                //         );
                //     };
                //     break;
                case 'playersList':
                    Wrapper = props => {
                        return (
                            <StandardComponentExample>
                                <DisplayElementTitle>{elementTitle}</DisplayElementTitle>
                                {props.children}
                            </StandardComponentExample>
                        );
                    };
                    break;
                default:
                    Wrapper = props => {
                        return (
                            <StandardComponentExample>
                                <DisplayElementTitle>{elementTitle}</DisplayElementTitle>
                                {props.children}
                            </StandardComponentExample>
                        );
                    };
            }

            if (['tournamentTable'].includes(element)) {
                return (
                    <Wrapper key={elementTitle}>
                        <Component.Container {...componentProps}>
                            <Component.Header {...componentProps} />
                            <Component.Row {...componentProps} />
                            <Component.Row {...componentProps} />
                        </Component.Container>
                    </Wrapper>
                );
            }

            if (['matchCell'].includes(element)) {
                return (
                    <Wrapper key={elementTitle}>
                        <Component.Container {...componentProps}>
                            <Component.MatchCellHeader {...componentProps} />
                            <Component.MatchCell {...componentProps} />
                        </Component.Container>
                    </Wrapper>
                );
            }

            if (['playersList'].includes(element)) {
                return (
                    <Wrapper key={elementTitle}>
                        <Component.Container {...componentProps}>
                            <Component.Header {...componentProps} />
                            <Component.Row {...componentProps} rank={0} />
                            <Component.Row {...componentProps} rank={1} />
                        </Component.Container>
                    </Wrapper>
                );
            }

            if (['h2hTable'].includes(element)) {
                return (
                    <Wrapper key={elementTitle}>
                        <Component.Container {...componentProps}>
                            <Component.Header {...componentProps} />
                            <Component.LatestFormRow {...componentProps} />
                            <Component.Rows {...componentProps} />
                            <Component.H2HRow {...componentProps} />
                        </Component.Container>
                    </Wrapper>
                );
            }

            return (
                <Wrapper key={elementTitle}>
                    <Component {...componentProps} />
                </Wrapper>
            );
        });

        return displayComponents;
    };

    handleCustomColorChange = (widgetId, colors) => {
        const { wid, template, variation, theme } = this.state;

        if (variation) {
            const customColors = _.get(theme, `variations.${wid}.${variation}.customColors`);
            _.set(theme, `variations.${wid}.${variation}.customColors`, { ...customColors, ...colors });
            _.set(template.theme, `variations.${wid}.${variation}.customColors`, { ...customColors, ...colors });

            _.set(theme, `variations.${wid}.${variation}.customColors`, { ...customColors, ...colors });
            _.set(theme, `customColors`, { ...customColors, ...colors });

            this.forceUpdate();
            this.setState({
                theme: { ...theme },
            });
        } else {
            const customColors = _.get(theme, `widgetsColors.${wid}`);
            console.log('!!!', customColors, theme);
            console.log('!!!!!!', widgetId, wid, colors);
            _.set(template.theme.widgetsColors, wid, { ...customColors, ...colors });
            _.set(theme.widgetsColors, wid, { ...customColors, ...colors });
            this.forceUpdate();

            this.setState({
                theme: { ...theme },
            });
        }
    };

    handleThemeChange = theme => {
        if (!theme) return;

        const { wid, template, variation } = this.state;

        if (wid) {
            const _theme = { ...this.state.template.theme }; // original loaded theme
            const changed = difference(theme, _theme); // DIFFERENCE TO ORIGINAL THEME
            if (!_.isEmpty(changed)) {
                if (variation) {
                    template.theme.variations = template.theme.variations || {};
                    template.theme.variations[`${wid}`] = template.theme.variations[`${wid}`] || {};
                    template.theme.variations[`${wid}`][variation] = _.omit(
                        {
                            ...changed,
                        },
                        ['widgets', 'widgetsColors', 'variations'],
                    );
                    this.setState({
                        theme,
                        changes: _.omit(changed, ['widgets', 'widgetsColors', 'variations']),
                    });
                } else {
                    template.theme.widgets = template.theme.widgets || {};
                    template.theme.widgets[wid] = _.omit(
                        {
                            ...changed,
                        },
                        ['widgets', 'widgetsColors', 'variations'],
                    );
                    this.setState({
                        theme,
                        changes: _.omit(changed, ['widgets', 'widgetsColors', 'variations']),
                    });
                }
            }
        } else {
            this.setState({ theme });
        }
    };

    handleWidgetResetProperty = key => {
        const { wid, widgets, template, theme } = this.state;
        _.unset(template, `theme.widgets.${wid}.${key}`);
        _.set(theme, `${key}`, _.get(template, `theme.${key}`));
        this.setState({ theme });
    };

    handlePropsChange = (key, value) => {
        const { template, tid, wid, variation } = this.state;

        if (variation) {
            template.theme.variations = template.theme.variations || {};
            template.theme.variations[`${wid}`] = template.theme.variations[`${wid}`] || {};
            _.set(template, `theme.variations[${wid}][${variation}].widgetProps[${key}]`, value);
            // template.theme.variations[`${wid}`].widgetProps = {}
        } else {
            _.set(template, `widgetProps.${wid}.${key}`, value);
        }

        this.setState({
            template,
        });

        const url = `${config.dash.api.host}/api/templates?id=${tid}`;
        return fetch(url, {
            method: 'post',
            body: JSON.stringify(template),
            headers: {
                'Content-Type': 'application/json',
                authorization: auth.getAccessToken(),
            },
        })
            .then(response => response.json())
            .then(tpl => {
                console.log('res', tpl);
            })
            .catch(err => {
                console.error(err);
                this.setState({ saveDialogue: false });
            });
    };

    renderEditor() {
        var { theme, template, tid, wid, variation, widgets } = this.state;

        const custom = _.get(template.theme, `widgets.${wid}`, null);
        const customVariation = _.get(template.theme, `variations.${wid}.${variation}`, null);

        const widgetProps = _.get(template, `widgetProps.${wid}`, {});
        const widgetPropsVariation = _.get(template.theme, `variations.${wid}.${variation}.widgetProps`, null);

        const widget = _.find(widgets, w => w.id === wid);

        return (
            <SplitImageTPLEditor
                ref="editor"
                key={`${wid}_${tid}_${variation}`}
                widgetId={wid}
                widget={widget}
                theme={theme}
                template={this.state.template}
                overriden={customVariation || custom || {}}
                widgetProps={widgetPropsVariation || widgetProps || {}}
                onChange={this.handleThemeChange}
                onCustomColorChange={this.handleCustomColorChange}
                onWidgetPropsChange={this.handlePropsChange}
                onWidgetResetProperty={this.handleWidgetResetProperty}
            />
        );
    }

    handleExport = id => () => {
        id = encodeURIComponent(id);

        this.setState({
            downloadTemplateProcess: true,
        });

        fetch(`${config.dash.api.host}/api/templates/${id}/export?access_token=${auth.getAccessToken()}`)
            .then(res => {
                if (res.status === 200) {
                    document.location.href = res.url;
                    return res;
                } else if (res.status === 403) throw new Error("You don't have access to template");
                else if (res.status === 404) throw new Error('Template not found');
                else throw new Error('Sorry, something went wrong');
            })
            .then(res => {
                this.setState({
                    downloadTemplateProcess: false,
                    snackbarOpen: true,
                    snackbarText: 'DONE: File downloaded',
                });
            })
            .catch(er => {
                this.setState({
                    downloadTemplateProcess: false,
                    downloadTemplateError: true,
                    snackbarOpen: true,
                    snackbarText: 'ERROR: ' + er.message,
                });
            });
    };

    handleImport = ev => {
        const fr = new FileReader();

        if (ev.target.files.length) {
            fr.readAsText(ev.target.files[0]);
        }

        fr.onloadstart = () => {
            this.setState({
                importFileLoaded: true,
            });
        };

        fr.onload = () => {
            let result;

            try {
                result = JSON.parse(fr.result);

                this.setState({
                    theme: result.theme,
                    template: {
                        ...this.state.template,
                        widgetProps: result.widgetProps,
                        theme: result.theme,
                    },
                    widgetTemplate: {
                        ...this.state.widgetTemplate,
                        widgetProps: result.widgetProps,
                        theme: result.theme,
                    },
                    snackbarOpen: true,
                    snackbarText: 'DONE: Theme imported',
                });
            } catch (er) {
                console.error(er, 'Error load file parse');

                this.setState({
                    snackbarOpen: true,
                    snackbarText: 'ERROR: Load file parse',
                });
            }
        };

        fr.onerror = er => {
            console.error(er, 'Error load file');

            this.setState({
                snackbarOpen: true,
                snackbarText: 'ERROR: Load file',
            });
        };

        fr.onloadend = () => {
            this.setState({
                importFileLoaded: false,
            });
        };
    };

    renderStandardPreview() { }

    render() {
        var { user } = this.context;
        var {
            tid,
            theme,
            template,
            wid,
            variation,
            widgets,
            downloadTemplateProcess,
            snackbarOpen,
            snackbarText,
            importFileLoaded,
            downloadTemplateError,
            widgetTemplate,
        } = this.state;

        if (!widgets) return <div>Loading</div>;

        const widget = _.find(widgets, w => w.id === wid);

        const customStylingsFor = _.chain(Object.keys(_.get(template, 'theme.widgets', [])))
            .map(wid => _.find(widgets, w => w.id === wid))
            .compact()
            .value();

        theme.editing = true;

        return (
            <div className="widget-customizer">
                <div className="widget-customizer__variables" style={{ zIndex: 11, paddingTop: '20px' }}>
                    {template && (
                        <rmd.Card className="card widget-params" initiallyExpanded>
                            <rmd.CardHeader
                                title={template && template.name}
                                subtitle={template && 'id: ' + template.id}
                            />
                            <rmd.CardText expandable style={{ padding: 0 }} />
                        </rmd.Card>
                    )}
                    {this.renderEditor()}
                </div>

                <div className="widget-customizer__content">
                    <rmd.Card className="card widget-preview" style={{ zIndex: 10 }}>
                        <rmd.Toolbar>
                            <rmd.ToolbarGroup>
                                <WidgetNestedMenu
                                    style={{ width: 350 }}
                                    title="Select widget"
                                    widgets={widgets}
                                    widgetId={wid}
                                    disabled={!tid}
                                    onChange={(event, value) => {
                                        this.props.router.replace({
                                            pathname: '/sm/templates/edit',
                                            query: {
                                                tid,
                                                wid: value.id,
                                                variation,
                                            },
                                        });
                                    }}
                                />
                                {wid && (
                                    <rmd.FlatButton
                                        label="Go to generic styling"
                                        onClick={() => {
                                            this.props.router.replace({
                                                pathname: '/sm/templates/edit',
                                                query: {
                                                    tid,
                                                },
                                            });
                                        }}
                                    />
                                )}
                                <rmd.FlatButton
                                    label="Default"
                                    onClick={e => {
                                        this.props.router.replace({
                                            pathname: '/sm/templates/edit',
                                            query: {
                                                tid,
                                                wid,
                                            },
                                        });
                                    }}
                                />
                                {wid &&
                                    Object.keys(_.get(widgetTemplate.theme, `variations.${wid}`, {}))
                                        .filter(key => key[0] === 'v')
                                        .map(v => (
                                            <rmd.FlatButton
                                                key={v}
                                                label={v}
                                                onClick={e => {
                                                    this.props.router.replace({
                                                        pathname: '/sm/templates/edit',
                                                        query: {
                                                            tid,
                                                            wid,
                                                            variation: v,
                                                        },
                                                    });
                                                }}
                                            />
                                        ))}
                            </rmd.ToolbarGroup>
                            <rmd.ToolbarGroup lastChild>
                                <rmd.FlatButton
                                    label="Reset widget colors"
                                    onClick={() => {
                                        this.handleThemeChange({
                                            ...this.state.theme,
                                            widgetsColors: { ...this.state.theme.widgetsColors, [wid]: null },
                                        });
                                    }}
                                />
                            </rmd.ToolbarGroup>
                        </rmd.Toolbar>
                        <rmd.CardText className="wdp-preview-container">
                            {wid && (
                                <PreviewContainerWrapper>
                                    {wid &&
                                        widget &&
                                        widget.spec &&
                                        widget.spec.demo &&
                                        widget.spec.demo.map(demo => {
                                            const CMP = _.get(window, `[rlz${wid}][${wid}]`);

                                            if (!CMP) return;

                                            return (
                                                <div
                                                    key={demo.title}
                                                    id="wdp-preview"
                                                    className="wdp-preview wdp-preview-800px"
                                                >
                                                    <p>
                                                        DEMO Widget - {demo.title || demo.name}{' '}
                                                        {_.get(user, 'props.lang')}
                                                    </p>
                                                    <WDPContext
                                                        client={user.client}
                                                        user={user.username}
                                                        token={user.accessToken}
                                                        lang={_.get(user, 'props.lang')}
                                                        key={_.get(template, 'id')}
                                                        social
                                                        variation={variation}
                                                    >
                                                        <CMP
                                                            name={wid}
                                                            {...demo.props}
                                                            social
                                                            tempTemplate={_.extend({}, template, { theme })}
                                                            variation={variation}
                                                            client={user.client}
                                                            user={user.username}
                                                            lang={_.get(user, 'props.lang')}
                                                            token={user.accessToken}
                                                            template={_.get(template, 'id')}
                                                        />
                                                    </WDPContext>
                                                </div>
                                            );
                                        })}
                                </PreviewContainerWrapper>
                            )}

                            {((tid && theme) || !tid) && !wid && (
                                <div id="wdp-preview" className="wdp-preview wdp-preview-800px">
                                    <WDPContext social>
                                        <SWTProvider templateData={template} userTheme={theme}>
                                            <div empty />
                                            <div>{this.renderDisplay()}</div>
                                        </SWTProvider>
                                    </WDPContext>
                                </div>
                            )}
                        </rmd.CardText>
                        <rmd.CardActions
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            {!tid && (
                                <rmd.FlatButton
                                    label="Create template"
                                    onClick={() => {
                                        this.setState({ saveDialogue: true });
                                    }}
                                />
                            )}
                            {tid && [
                                <div
                                    key="1"
                                    style={{
                                        textAlign: 'left',
                                        flexGrow: 1,
                                    }}
                                >
                                    <rmd.FlatButton label="Save changes" onClick={this.handleSaveOrUpdate} />
                                </div>,
                                <div key="2">
                                    <rmd.FlatButton
                                        label="Import"
                                        style={{ position: 'relative' }}
                                        icon={importFileLoaded ? <rmd.CircularProgress size={24} /> : <IconUpload />}
                                    >
                                        <label
                                            htmlFor="import-file"
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0,
                                                opacity: 0,
                                                zIndex: 9,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Import
                                        </label>
                                    </rmd.FlatButton>
                                    <input
                                        hidden
                                        accept="application/json"
                                        type="file"
                                        id="import-file"
                                        onChange={this.handleImport}
                                    />
                                </div>,
                                <rmd.FlatButton
                                    key="export"
                                    label="Export"
                                    onClick={this.handleExport(template.id)}
                                    disabled={downloadTemplateError}
                                    icon={(() => {
                                        if (downloadTemplateError) {
                                            return <IconError />;
                                        } else if (downloadTemplateProcess) {
                                            return <rmd.CircularProgress size={24} />;
                                        } else {
                                            return <IconDownload />;
                                        }
                                    })()}
                                />,
                            ]}
                        </rmd.CardActions>
                    </rmd.Card>

                    {customStylingsFor.length !== 0 && (
                        <rmd.Card style={{ margin: '16px 0' }}>
                            <rmd.CardHeader title="Individually styled widgets" />
                            <rmd.Divider />
                            <rmd.List defaultValue={wid}>
                                {customStylingsFor.map(w => {
                                    return (
                                        <rmd.ListItem
                                            style={{ backgroundColor: wid === w.id ? '#eaeaea' : null }}
                                            key={w.id}
                                            primaryText={w.name}
                                            secondaryText={Object.keys(template.theme.widgets[w.id]).join(', ')}
                                            onClick={e => {
                                                this.props.router.replace(`/sm/templates/edit?tid=${tid}&wid=${w.id}`);
                                            }}
                                        />
                                    );
                                })}
                            </rmd.List>
                        </rmd.Card>
                    )}

                    <rmd.Dialog
                        title="Save this template"
                        actions={_.compact([
                            <rmd.FlatButton
                                label="Close"
                                onClick={() => {
                                    this.setState({ saveDialogue: false });
                                }}
                            />,
                            <rmd.FlatButton primary label="Save changes" onClick={this.handleSaveOrUpdate} />,
                        ])}
                        modal={false}
                        open={this.state.saveDialogue}
                        onRequestClose={this.handleClose}
                    >
                        <rmd.TextField
                            ref="name"
                            key="name"
                            name={this.state.name}
                            floatingLabelText="Template name"
                            style={{ width: '100%' }}
                            onChange={(e, name) => {
                                this.setState({ name });
                            }}
                        />
                    </rmd.Dialog>
                    <Snackbar
                        open={snackbarOpen}
                        message={snackbarText || 'Sorry, there was an error'}
                        autoHideDuration={5000}
                        onRequestClose={() => {
                            this.setState({
                                snackbarOpen: false,
                                snackbarText: '',
                            });
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default TemplateCustomizer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/TemplateCustomizer.js
 **/